import { h } from 'preact'
import Content from '../common/Content'

interface Props {
  description: string
}

const GroupDescription = ({ description }: Props) => (
  <div className='widget group-details_description'>
    <div className='group-content-container'>
      <h3 className='widget-title'>About this group</h3>
      <Content content={description} className='group__content' />
    </div>
  </div>
)

export default GroupDescription
